/* globals SystemMessages */

window['system_messages#edit'] = function () {
  SystemMessages.editable_fields()
}
